// import loader from "../../../images/flask.gif";
import { Spin } from "antd";

const Loader = () => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        zIndex: 1000,
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Loader;
